export default __webpack_public_path__ + "static/media/PRCbanner.327dfeca.png";